// src/app/core/interceptors/auth.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '../port/authentication.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  const token = authService.getToken();

  // Exclure les URLs Firebase et Google de l'authentification
  const isFirebaseUrl = req.url.includes('googleapis.com') || 
                       req.url.includes('firebase') || 
                       req.url.includes('identitytoolkit') ||
                       req.url.includes('securetoken.googleapis.com');

  console.log(`🔍 HTTP Request: ${req.method} ${req.url}`);
  console.log(`🔑 Token exists: ${!!token}`);
  console.log(`🔥 Is Firebase URL: ${isFirebaseUrl}`);

  if (token && !isFirebaseUrl) {
    console.log(`✅ Adding Authorization header to: ${req.url}`);
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return next(cloned);
  } else {
    console.log(`❌ No Authorization header for: ${req.url}`);
    return next(req);
  }
};
